import { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react/macro";

type JESTLinguiTMock = (descriptor: MessageDescriptor) => string;

export type LinguiT = ReturnType<typeof useLingui>["t"] | JESTLinguiTMock;
export type LinguiI18n = ReturnType<typeof useLingui>["i18n"];

export const translationOrString = (
  t: LinguiT,
  translation: string | MessageDescriptor
) => {
  if (isString(translation)) return translation;
  return t(translation);
};

export const maybeTranslation = (
  t: LinguiT,
  translation: string | MessageDescriptor | undefined
) => {
  if (!translation) return undefined;
  return translationOrString(t, translation);
};

function isString(x: string | MessageDescriptor | undefined): x is string {
  return typeof x == "string";
}
